import { createContext } from 'react';

export const PerfiladorContext = createContext({});
